export const dailyRoomOccupancyColumns = [
  { Header: 'Sl. No.', accessor: 'Sl' },
  { Header: 'Occupancy Date', accessor: 'OccupancyDate' },
  { Header: 'Total Room Occupied', accessor: 'TotalCount' },
  { Header: 'Room Breakup', accessor: 'RoomBreakup' }
];
